/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import Page from '../../Page';
import { notifyUncaughtErrors } from '../../../utils/extractErrorMessage';

import { Routes } from '../../../data/Routes';
import Locale from '../../../data/Locale';
import PaymentTerm from '../../../data/PaymentTerm';
import PeriodicInvoiceConceptModel from '../../../stores/models/PeriodicInvoiceConceptModel';
import BTW from '../../../data/BTW';

import Signals from '../../../signals/Signals';

import InvoiceConceptRow from '../Invoice/components/InvoiceConceptRow';
import InfoIcon from '../../../components/ui/InfoIcon/InfoIcon';
import ModalAlert from '../../../components/ui/Modal/ModalAlert';
import FormGroup from '../../../components/ui/FormGroup/FormGroup';
import FormField from '../../../components/ui/FormField/FormField';

import DropDown from '../../../components/ui/DropDown/DropDown';
import Switch from '../../../components/ui/Switch/Switch';
import InvoiceConceptSummaryRow from '../Invoice/components/InvoiceConceptSummaryRow';
import DateInput from '../../../components/ui/DateInput/DateInput';
import CompanyCustomerSearch from '../../../components/ui/CompanyCustomerSearch/CompanyCustomerSearch';
import CompanyBrandSearch from '../../../components/ui/CompanyBrandSearch/CompanyBrandSearch';

import FileUploadList from '../../../components/ui/FileUpload/FileUploadList';
import { ApplicationContext } from '../../../ApplicationContext';
import { FormErrorContext } from '../../../FormErrorContext';

import CookieController, { COOKIE_TYPES } from '../../../controllers/CookieController';
import PropertiesController from '../../../controllers/PropertiesController';
import AlertMessage from '../../../components/ui/AlertMessage/AlertMessage';
import PeriodicScheduleInterval from '../../../data/PeriodicScheduleInterval';
import GetPeriodicInvoicesConceptCommand from '../../../commands/periodicInvoiceConcepts/GetPeriodicInvoicesConceptCommand';
import SavePeriodicInvoiceConceptCommand from '../../../commands/periodicInvoiceConcepts/SavePeriodicInvoiceConceptCommand';
import Checkbox from '../../../components/ui/Checkbox/Checkbox';

//
const localesArray = [Locale.nl_NL, Locale.en_US];

/**
 *
 */
@observer
class PeriodicInvoiceConcept extends React.Component {
	/**
	 *
	 * @param props
	 */
	constructor(props) {
		super(props);

		this.periodicInvoiceConceptModel = null;

		this.state = {
			submitting: false,
			dragging: null
		};

		this.onCancel = this.onCancel.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onError = this.onError.bind(this);

		this.onDragStart = this.onDragStart.bind(this);
		this.onDragEnd = this.onDragEnd.bind(this);
		this.onDragOver = this.onDragOver.bind(this);
		this.onDragUpdate = this.onDragUpdate.bind(this);

		this.onStartDateChange = this.onStartDateChange.bind(this);
		this.onEndDateChange = this.onEndDateChange.bind(this);
		this.onClientChange = this.onClientChange.bind(this);
		this.onBrandChange = this.onBrandChange.bind(this);
		this.onInputChange = this.onInputChange.bind(this);
		this.onAutoSendCheck = this.onAutoSendCheck.bind(this);

		this.onAttachmentsChange = this.onAttachmentsChange.bind(this);

		this.showProjectOrderInfo = this.showProjectOrderInfo.bind(this);

		this.addNewInvoiceConceptRow = this.addNewInvoiceConceptRow.bind(this);
		this.onInvoiceConceptRowChange = this.onInvoiceConceptRowChange.bind(this);
		this.onInvoiceConceptRowRemove = this.onInvoiceConceptRowRemove.bind(this);

		this.onCompanyCustomerAdded = this.onCompanyCustomerAdded.bind(this);
		this.onCompanyBrandAdded = this.onCompanyBrandAdded.bind(this);

		this.fieldHeaderSettings = [
			{ id: 'dragicon', labelId: '' },
			{ id: 'description', labelId: 'invoice.header.description' },
			{ id: 'units', labelId: 'invoice.header.units', center: true },
			{ id: 'unitprice', labelId: 'invoice.header.unitprice', center: true },
			{ id: 'btw', labelId: 'invoice.header.btw', center: true },
			{ id: 'amount', labelId: 'invoice.header.amount', right: true },
			{ id: 'remove', labelId: 'invoice.header.remove' }
		];
	}

	/**
	 *
	 */
	componentWillMount() {
		Signals.CompanyCustomerAdded.add(this.onCompanyCustomerAdded);
		Signals.CompanyBrandAdded.add(this.onCompanyBrandAdded);
		this._initialize();
	}

	/**
	 *
	 * @param nextProps
	 * @param nextContext
	 */
	componentWillReceiveProps(_nextProps, _nextContext) {
		this._initialize();
	}

	/**
	 *
	 */
	componentWillUnmount() {
		Signals.CompanyCustomerAdded.remove(this.onCompanyCustomerAdded);
		Signals.CompanyBrandAdded.remove(this.onCompanyBrandAdded);
	}

	/**
	 *
	 * @param prevProps
	 * @param prevState
	 * @param snapshot
	 */
	componentDidUpdate(_prevProps, _prevState, _snapshot) {
		notifyUncaughtErrors(this.state, this.props.intl);
	}

	/**
	 *
	 * @returns {*}
	 */
	render() {
		// Check if user logged in, and we have company
		const company = this.context.applicationStore.getSelectedCompany();
		const user = this.context.applicationStore.user;

		const tableBodyClasses = classNames({
			table__body: true,
			'table__body--dragging': !!this.state.dragging
		});

		//
		if (!this.periodicInvoiceConceptModel || !company || !user) {
			return null;
		}

		const inclVat = this.periodicInvoiceConceptModel.getInclVat();
		const { intl } = this.props;
		const { errors } = this.state;

		return (
			<Page pageName="periodic-invoice-concept grid">
				{PropertiesController.getProperty(PropertiesController.FEATURE_DEMO, this.context) ? (
					<AlertMessage
						className="periodic-invoice-concept__demo-warning"
						title={this.props.intl.formatMessage({ id: 'demo.invoiceconcept.warning' })}
						warning
					/>
				) : null}

				<FormErrorContext.Provider value={{ errors }}>
					<form
						ref={(el) => {
							this.el = el;
						}}
						className="periodic-invoice-concept__panel panel grid col--12 box-shadow border border--dark"
						onSubmit={this.onSubmit}>
						<div className="periodic-invoice-concept__options-top padding-small border--bottom border--dark grid grid--spread col--12">
							{this._getOptionButtons()}
						</div>

						<div className="periodic-invoice-concept__settings col--12 grid padding">
							<FormGroup className="col--12">
								<FormField className="col--6">
									<label>
										<FormattedMessage id="invoice.settings.brand" />
									</label>
									{this._getCompanyBrandSearch()}
								</FormField>
								<FormField className="col--6">
									<label>
										<FormattedMessage id="invoice.settings.client" />
									</label>
									{this._getCompanyCustomerSearch()}
								</FormField>

								<FormField className="col--3 form-field__date-picker invoice-concept__form-field-stretch">
									<label>
										<FormattedMessage id="invoice.settings.startdate" />
									</label>
									<DateInput
										className="periodic-invoice-concept__startdate"
										name="startDate"
										autoComplete="off"
										required
										value={this.periodicInvoiceConceptModel.periodicSchedule.startDate}
										onChange={this.onStartDateChange}
									/>
								</FormField>

								<FormField className="col--3 form-field__date-picker invoice-concept__form-field-stretch">
									<label>
										<FormattedMessage id="invoice.settings.interval" />
									</label>
									<div className="periodic-invoice-concept__amount-interval-wrapper grid grid--no-wrap">
										<input
											className="col--4"
											name="amount"
											type="number"
											min={1}
											max={99}
											step={1}
											onChange={this.onInputChange}
											value={this.periodicInvoiceConceptModel.periodicSchedule.amount}
										/>
										<DropDown
											name="interval"
											className="col--8"
											onChange={this.onInputChange}
											value={this.periodicInvoiceConceptModel.periodicSchedule.interval}>
											<option value={PeriodicScheduleInterval.DAILY}>
												{intl.formatMessage(
													{ id: 'periodicscheduleinterval.DAILY' },
													{ count: this.periodicInvoiceConceptModel.periodicSchedule.amount }
												)}
											</option>
											<option value={PeriodicScheduleInterval.WEEKLY}>
												{intl.formatMessage(
													{ id: 'periodicscheduleinterval.WEEKLY' },
													{ count: this.periodicInvoiceConceptModel.periodicSchedule.amount }
												)}
											</option>
											<option value={PeriodicScheduleInterval.MONTHLY}>
												{intl.formatMessage(
													{ id: 'periodicscheduleinterval.MONTHLY' },
													{ count: this.periodicInvoiceConceptModel.periodicSchedule.amount }
												)}
											</option>
										</DropDown>
									</div>
								</FormField>

								<FormField className="col--6 ">
									<label>
										<FormattedMessage id="invoice.settings.projectcode" />
										<InfoIcon onClick={this.showProjectOrderInfo} />
									</label>
									<input
										name="projectcode"
										type="text"
										value={this.periodicInvoiceConceptModel.projectcode}
										onChange={this.onInputChange}
									/>
								</FormField>

								<FormField className="col--3 form-field__date-picker invoice-concept__form-field-stretch">
									<label>
										<FormattedMessage id="invoice.settings.enddate" />
									</label>
									<DateInput
										className="periodic-invoice-concept__enddate"
										name="endDate"
										autoComplete="off"
										required
										value={this.periodicInvoiceConceptModel.periodicSchedule.endDate}
										onChange={this.onEndDateChange}
									/>
								</FormField>

								<FormField className="col--3 invoice-concept__form-field-stretch">
									<label>
										<FormattedMessage id="invoice.settings.expirationterm" />
									</label>

									<div className="col--12 grid grid--no-wrap">
										<input
											type="number"
											className="grid-grow-1 has-suffix"
											name="expirationDays"
											value={this.periodicInvoiceConceptModel.expirationDays}
											onChange={this.onInputChange}
											required
											min={1}
											max={120}
											step={1}
										/>

										<div className="no-shrink form-field__input-suffix">
											<FormattedMessage id="invoice.payment.label.days" />
										</div>
									</div>
								</FormField>

								<FormField className="col--6 invoice-concept__form-field-stretch">
									<label>
										<FormattedMessage id="invoice.settings.language" />
									</label>
									<DropDown
										value={this.periodicInvoiceConceptModel.locale}
										className="col--12"
										name="locale"
										onChange={this.onInputChange}>
										{this._getLocaleOptions()}
									</DropDown>
								</FormField>
							</FormGroup>

							<FormGroup className="col--12">
								<FormField className="col--12">
									<label>
										<FormattedMessage id="invoice.subject.label" />
									</label>
									<input
										name="subject"
										value={this.periodicInvoiceConceptModel.subject}
										type="text"
										placeholder={intl.formatMessage({ id: 'invoice.subject.placeholder' })}
										onChange={this.onInputChange}
										maxLength={255}
										required
									/>
								</FormField>
							</FormGroup>

							<FormGroup className="col--12">
								<FormField className="col--12">
									<Checkbox
										onChange={this.onAutoSendCheck}
										name="sendInvoiceToCustomerAutomatically"
										label={intl.formatMessage({ id: 'invoice.settings.autosend' })}
										checked={this.periodicInvoiceConceptModel.sendInvoiceToCustomerAutomatically}
									/>
								</FormField>
							</FormGroup>
						</div>

						<div className="periodic-invoice-concept__rows-wrapper">
							<div className="periodic-invoice-concept__options-middle grid grid--right border--top">
								<Switch
									checked={inclVat}
									name="inclVat"
									useState={false}
									label={
										inclVat
											? intl.formatMessage({ id: 'invoice.settings.label.inclvat' })
											: intl.formatMessage({ id: 'invoice.settings.label.exclvat' })
									}
									onChange={this.onInputChange}
								/>
							</div>

							<table className="periodic-invoice-concept__rows col--12">
								<thead className="table__headers">
									<tr>{this._getTableHeaders()}</tr>
								</thead>
								<tbody className={tableBodyClasses} onDragOver={this.onDragOver}>
									{this._getInvoiceConceptRows()}
								</tbody>
								<tfoot>
									{/* subtotal */}
									<InvoiceConceptSummaryRow
										label={intl.formatMessage({ id: 'invoice.summary.subtotal' })}
										amount={this.periodicInvoiceConceptModel.getSubtotal()}
									/>

									{/* btw laag */}
									<InvoiceConceptSummaryRow
										hideWhenZero={!this.periodicInvoiceConceptModel.containsVATType(BTW.LAAG)}
										label={intl.formatMessage(
											{ id: 'invoice.summary.btw' },
											{ percentage: intl.formatMessage({ id: BTW.LAAG.translationId() }) }
										)}
										amount={this.periodicInvoiceConceptModel.getBTWTotal(BTW.LAAG.name)}
									/>
									{/* btw hoog */}
									<InvoiceConceptSummaryRow
										hideWhenZero={!this.periodicInvoiceConceptModel.containsVATType(BTW.HOOG)}
										label={intl.formatMessage(
											{ id: 'invoice.summary.btw' },
											{ percentage: intl.formatMessage({ id: BTW.HOOG.translationId() }) }
										)}
										amount={this.periodicInvoiceConceptModel.getBTWTotal(BTW.HOOG.name)}
									/>

									{this._getVATReversed()}
									{this._getVATExempt()}

									<InvoiceConceptSummaryRow
										label={intl.formatMessage({ id: 'invoice.summary.total' })}
										amount={this.periodicInvoiceConceptModel.getTotal()}
									/>
								</tfoot>
							</table>
						</div>

						{/* Notes */}
						<div className="periodic-invoice-concept__extra col--12 grid padding">
							<FormGroup className="col--12">
								<FormField className="col--12">
									<label>
										<FormattedMessage id="invoice.notes.label" />
									</label>
									<textarea
										name="notes"
										placeholder={intl.formatMessage({ id: 'invoice.notes.placeholder' })}
										className="periodic-invoice-concept__notes col--12"
										value={this.periodicInvoiceConceptModel.notes}
										onChange={this.onInputChange}
									/>
								</FormField>
							</FormGroup>
						</div>

						{/* Attachments */}
						<div className="periodic-invoice-concept__attachments col--7 grid padding">
							<FormGroup className="col--12">
								<FormField className="col--12">
									<label>
										<FormattedMessage id="invoice.attachments.label" />
									</label>
									<FileUploadList
										fileAssets={this.periodicInvoiceConceptModel.assetAttachments}
										maxTotalFileSize={20971520} // 20Mb
										onChange={this.onAttachmentsChange}
									/>
								</FormField>
							</FormGroup>
						</div>

						{/* Options (Cancel/Save) */}
						<div className="periodic-invoice-concept__options-bottom padding-small border--top border--dark grid grid--spread col--12">
							{this._getOptionButtons()}
						</div>
					</form>
				</FormErrorContext.Provider>
			</Page>
		);
	}

	/**
	 *
	 * @param e
	 * @param date
	 */
	onStartDateChange(e, date) {
		this.periodicInvoiceConceptModel.periodicSchedule.startDate = date;
		this.forceUpdate();
	}

	/**
	 *
	 * @param e
	 * @param date
	 */
	onEndDateChange(e, date) {
		this.periodicInvoiceConceptModel.periodicSchedule.endDate = date;
		this.forceUpdate();
	}

	/**
	 *
	 * @param companyCustomer
	 */
	onClientChange(companyCustomer) {
		this.periodicInvoiceConceptModel.companyCustomer = companyCustomer;
		this.forceUpdate();
	}

	/**
	 *
	 * @param companyBrand
	 */
	onBrandChange(companyBrand) {
		const { applicationStore } = this.context;
		if (!companyBrand) {
			const company = applicationStore.getSelectedCompany();
			companyBrand = company.defaultCompanyBrand;
		}
		CookieController.setCookie(COOKIE_TYPES.SELECTED_COMPANY_BRAND_ID, companyBrand.id);
		this.periodicInvoiceConceptModel.companyBrand = companyBrand;

		this.forceUpdate();
	}

	/**
	 *
	 * @param e
	 */
	onInputChange(e) {
		switch (e.target.name) {
			case 'expirationDays':
				// eslint-disable-next-line no-case-declarations
				const days = parseInt(e.target.value, 10);
				this.periodicInvoiceConceptModel[e.target.name] = !isNaN(days)
					? days
					: PaymentTerm.FOURTEEN_DAYS;
				break;
			case 'locale':
				this.periodicInvoiceConceptModel.locale = e.target.value;
				this._updateNotes();
				break;
			case 'inclVat':
				// toggle incl/excl vat
				this.periodicInvoiceConceptModel.setInclVat(!e.target.checked);
				break;
			case 'interval':
				this.periodicInvoiceConceptModel.periodicSchedule.interval = e.target.value;
				break;
			case 'amount':
				this.periodicInvoiceConceptModel.periodicSchedule.amount = e.target.value;
				break;
			default:
				this.periodicInvoiceConceptModel[e.target.name] = e.target.value;
		}

		this.forceUpdate();
	}

	/**
	 *
	 */
	onAutoSendCheck(event) {
		this.periodicInvoiceConceptModel.sendInvoiceToCustomerAutomatically = event.target.checked;
	}

	/**
	 *
	 */
	onCancel() {
		const company = this.context.applicationStore.getSelectedCompany();
		if (company) {
			if (this.periodicInvoiceConceptModel.id) {
				Signals.RequestRoute.dispatch(
					Routes.COMPANY_INVOICES_PERIODIC_INVOICE.getPath({
						id: company.id,
						invoiceId: this.periodicInvoiceConceptModel.id
					})
				);
			} else {
				Signals.RequestRoute.dispatch(
					Routes.COMPANY_INVOICES_PERIODIC_ALL.getPath({ id: company.id })
				);
			}
		}
	}

	/**
	 *
	 * @param e
	 */
	onSubmit(e) {
		if (e) {
			e.preventDefault();
		}

		if (this.state.submitting) {
			return;
		}

		// Blur active element
		if ('activeElement' in document) {
			document.activeElement.blur();
		}

		this.doSubmit();
	}

	/**
	 *
	 * @param error
	 */
	onError(error) {
		if (error.response && error.response.body) {
			// error.response.body
			this.setState({ errors: error.response.body, submitting: false });
		} else {
			Signals.Error.dispatch(error);
			this.setState({ submitting: false });
		}
	}

	/**
	 *
	 */
	onDragStart(invoiceConceptRowModel, event) {
		const draggingContainer = document.querySelector('.invoice-concept__rows tbody');
		const draggingElements = draggingContainer.querySelectorAll('.invoice-concept-row');
		const elementRect = event.target.getBoundingClientRect();
		const elementCenterY = elementRect.y + elementRect.height * 0.5;
		this.dragOffsetY = event.clientY - elementCenterY;

		this.setState({
			dragging: invoiceConceptRowModel,
			draggingContainer,
			draggingElements
		});

		this.dragUpdateInterval = setInterval(this.onDragUpdate, 31);
	}

	/**
	 *
	 * @param invoiceConceptRowModel
	 */
	onDragEnd(_invoiceConceptRowModel) {
		clearInterval(this.dragUpdateInterval);
		this.dragClientY = null;
		this.setState({ dragging: null, draggingElements: null, draggingContainer: null });
	}

	/**
	 *
	 */
	onDragUpdate() {
		const { dragging, draggingElements } = this.state;

		if (dragging && this.dragClientY) {
			const draggingUid = `${dragging._uid}`;
			const positionY = this.dragClientY - this.dragOffsetY;
			const before = [];
			const element = [];
			const after = [];

			// Determine order
			draggingElements.forEach((rowElement) => {
				const rect = rowElement.getBoundingClientRect();

				if (rowElement.dataset.uid !== draggingUid) {
					if (positionY <= rect.y + rect.height * 0.5) {
						after.push(rowElement);
					} else {
						before.push(rowElement);
					}
				} else {
					element.push(rowElement);
				}
			});

			// Apply order
			const ordered = before.concat(element).concat(after);
			const result = [];
			ordered.forEach((rowElement, index) => {
				const uid = rowElement.dataset.uid;
				const invoiceConceptRowModel = this.periodicInvoiceConceptModel.getConceptRowByUid(
					parseInt(uid, 10)
				);
				invoiceConceptRowModel.sortOrder = index;
				result.push(invoiceConceptRowModel);
			});

			// Update invoiceConceptRows order
			this.periodicInvoiceConceptModel.invoiceConceptRows = result;
			this.forceUpdate();
		}
	}

	/**
	 *
	 * @param event
	 */
	onDragOver(event) {
		event.preventDefault();
		this.dragClientY = event.clientY;
	}

	/**
	 *
	 * @param id
	 */
	onCompanyCustomerAdded(id) {
		this.periodicInvoiceConceptModel.companyCustomer =
			this.context.applicationStore.companyCustomerStore.find(parseInt(id, 10));
		this.forceUpdate();
	}

	/**
	 *
	 * @param id
	 */
	onCompanyBrandAdded(id) {
		this.periodicInvoiceConceptModel.companyBrand =
			this.context.applicationStore.companyBrandStore.find(parseInt(id, 10));
		this.forceUpdate();
	}

	/**
	 *
	 */
	onInvoiceConceptRowChange() {
		this.forceUpdate();
	}

	/**
	 *
	 * @param invoiceConceptRowModel
	 */
	onInvoiceConceptRowRemove(invoiceConceptRowModel) {
		this.periodicInvoiceConceptModel.removeConceptRow(invoiceConceptRowModel);
		this.forceUpdate();
	}

	/**
	 *
	 */
	doSubmit() {
		// Blur active element
		if ('activeElement' in document) {
			document.activeElement.blur();
		}

		// Validate
		const currentDate = new Date(Date.now());
		const company = this.context.applicationStore.getSelectedCompany();
		const year = this.periodicInvoiceConceptModel.periodicSchedule.startDate
			? this.periodicInvoiceConceptModel.periodicSchedule.startDate.getFullYear()
			: null;
		const financialYear = company.getFinancialYearByYear(year);

		// Check if date is not in current year or later
		if (year && year < currentDate.getFullYear()) {
			if (!financialYear || financialYear.isClosed()) {
				const translationTitleId = 'invoice.wrongbookyear.alert.title';
				const translationId = 'invoice.wrongbookyear.alert.description';
				Signals.ShowModal.dispatch(
					<ModalAlert
						title={this.props.intl.formatMessage({ id: translationTitleId })}
						body={this.props.intl.formatMessage({ id: translationId })}
					/>
				);
				return;
			}
		}

		// Prepare requests
		this.setState({ errors: null, submitting: true });
		const defaults = {
			senderEmail: this.context.applicationStore.user.email,
			notes: ''
		};

		const data = JSON.parse(this.periodicInvoiceConceptModel.toJSON(defaults));
		const saveCommand = new SavePeriodicInvoiceConceptCommand(
			this.context.applicationStore,
			this.periodicInvoiceConceptModel,
			company,
			data
		);
		saveCommand
			.execute(() => {
				this.setState({ submitting: false });
			})
			.catch(this.onError);
	}

	/**
	 *
	 * @param fileAssets FileAssets
	 */
	onAttachmentsChange(fileAssets) {
		this.periodicInvoiceConceptModel.assetAttachments = fileAssets;
	}

	/**
	 *
	 */
	showProjectOrderInfo() {
		const translationTitleId = 'info.projectcode.title';
		const translationId = 'info.projectcode.body';
		Signals.ShowModal.dispatch(
			<ModalAlert
				title={this.props.intl.formatMessage({ id: translationTitleId })}
				body={this.props.intl.formatMessage({ id: translationId })}
			/>
		);
	}

	/**
	 *
	 */
	addNewInvoiceConceptRow() {
		this.periodicInvoiceConceptModel.addNewConceptRow();
		this.forceUpdate();
	}

	/**
	 * @private
	 */
	_getCompanyCustomerSearch() {
		const { intl } = this.props;
		const { applicationStore } = this.context;
		let showChangeOnly = false;

		const companyCustomerId = this.periodicInvoiceConceptModel.getCompanyCustomerId();
		const currentCompanyCustomer = this.periodicInvoiceConceptModel.companyCustomer;

		// If companyCustomerId is found on invoiceconcept, compare to stored version
		if (companyCustomerId) {
			const savedCompanyCustomer = applicationStore.companyCustomerStore.find(companyCustomerId);

			if (!savedCompanyCustomer || !savedCompanyCustomer.isEqual(currentCompanyCustomer)) {
				showChangeOnly = true;
			}
		}

		//
		return (
			<CompanyCustomerSearch
				name="companyCustomer"
				value={this.periodicInvoiceConceptModel.getCompanyCustomerId()}
				initialCompanyCustomer={currentCompanyCustomer}
				placeholder={intl.formatMessage({ id: 'company.customerselect.placeholder' })}
				changeOnly={showChangeOnly}
				onChange={this.onClientChange}
			/>
		);
	}

	/**
	 *
	 * @return {*}
	 * @private
	 */
	_getCompanyBrandSearch() {
		const { intl } = this.props;
		const { applicationStore } = this.context;
		const company = applicationStore.getSelectedCompany();

		let currentCompanyBrandId = this.periodicInvoiceConceptModel.getCompanyBrandId()
			? this.periodicInvoiceConceptModel.getCompanyBrandId()
			: parseInt(CookieController.getCookie(COOKIE_TYPES.SELECTED_COMPANY_BRAND_ID), 10);
		const currentCompanyBrand = this.periodicInvoiceConceptModel.companyBrand;
		let showChangeOnly = false;

		// If companybrand is found on offer, compare to stored version
		if (currentCompanyBrandId >= 0) {
			const savedCompanyBrand = applicationStore.companyBrandStore.find(currentCompanyBrandId);
			if (!savedCompanyBrand || !savedCompanyBrand.isEqual(currentCompanyBrand)) {
				showChangeOnly = true;
			}
			// Default is used, compare if same as current default
		} else if (currentCompanyBrandId === -1 && currentCompanyBrand) {
			showChangeOnly = !currentCompanyBrand.isEqual(company.defaultCompanyBrand);
			// No companybrand store, set -1 to select default
		} else {
			currentCompanyBrandId = -1; // set default
			this.periodicInvoiceConceptModel.companyBrand = company.defaultCompanyBrand;
		}

		//
		return (
			<CompanyBrandSearch
				name="companyBrand"
				value={currentCompanyBrandId}
				initialCompanyBrand={currentCompanyBrand}
				placeholder={intl.formatMessage({ id: 'company.brandselect.placeholder' })}
				includeDefault
				changeOnly={showChangeOnly}
				onChange={this.onBrandChange}
			/>
		);
	}

	/**
	 *
	 * @return {*}
	 * @private
	 */
	_getInvoiceConceptRows() {
		// Create invoices concept rows
		const rows = this.periodicInvoiceConceptModel.invoiceConceptRows.map(
			(invoiceConceptRowModel, index) => {
				invoiceConceptRowModel.sortOrder = index;
				return (
					<InvoiceConceptRow
						key={`i-${invoiceConceptRowModel._uid}-${invoiceConceptRowModel.id}`}
						invoiceConceptRowModel={invoiceConceptRowModel}
						invoiceConceptModel={this.periodicInvoiceConceptModel}
						onChange={this.onInvoiceConceptRowChange}
						onRemove={this.onInvoiceConceptRowRemove}
						onDragStart={this.onDragStart}
						onDragEnd={this.onDragEnd}
					/>
				);
			}
		);

		// Add new row
		rows.push(
			<tr
				key="add-invoice-concept-row"
				className="invoice-concept__add-invoice-concept-row border--top border--dark"
				onClick={this.addNewInvoiceConceptRow}>
				<td
					className="invoice-concept-row__column invoice-concept-row__add icon icon--left icon--add-black"
					colSpan={7}>
					<FormattedMessage id="invoice.add.row" />
				</td>
			</tr>
		);

		return rows;
	}

	/**
	 *
	 * @return {any[]}
	 * @private
	 */
	_getTableHeaders() {
		let totalUnits = 0;
		if (this.periodicInvoiceConceptModel) {
			this.periodicInvoiceConceptModel.invoiceConceptRows.forEach((invoiceConceptRow) => {
				totalUnits += invoiceConceptRow.units;
			});
		}
		const values = { totalUnits: ` (${totalUnits})` };

		// Create table headers
		return this.fieldHeaderSettings.map((fieldData, index) => {
			if (fieldData.hide) return null;

			return (
				<td
					key={`ih-${index}`}
					className={`invoice-concept__header--${fieldData.id.toLowerCase()} ${classNames({
						table__header: true,
						'table__header--center': fieldData.center,
						'table__header--right': fieldData.right,
						'table__header--no-sort': fieldData.noSort
					})}`}>
					{fieldData.labelId ? <FormattedMessage id={fieldData.labelId} values={values} /> : ''}
				</td>
			);
		});
	}

	/**
	 *
	 * @return {*[]}
	 * @private
	 */
	_getLocaleOptions() {
		// Locale options
		return localesArray.map((locale, index) => {
			return (
				<option key={`locale-${index}`} value={locale}>
					{this.props.intl.formatMessage({ id: `locale.${locale}` })}
				</option>
			);
		});
	}

	/**
	 *
	 * @returns {*}
	 * @private
	 */
	_getVATExempt() {
		if (this.periodicInvoiceConceptModel.containsVATType(BTW.VRIJGESTELD)) {
			return (
				<InvoiceConceptSummaryRow
					label={this.props.intl.formatMessage({ id: 'invoice.vat.exempt.summary' })}
					amount={null}
				/>
			);
		}

		return null;
	}

	/**
	 *
	 * @returns {*}
	 * @private
	 */
	_getVATReversed() {
		if (this.periodicInvoiceConceptModel.containsVATType(BTW.VERLEGD)) {
			return (
				<InvoiceConceptSummaryRow
					label={this.props.intl.formatMessage({ id: 'invoice.vat.reversed.summary' })}
					amount={0}
				/>
			);
		}

		return null;
	}

	/**
	 *
	 * @returns {Array}
	 * @private
	 */
	_getOptionButtons() {
		const buttons = [];

		buttons.push(
			<button
				key="btn-cancel"
				className="button--tertiary button--no-shadow"
				onClick={this.onCancel}
				type="button">
				<FormattedMessage id="label.cancel" />
			</button>
		);

		buttons.push(
			<button
				key="btn-submit"
				className="button--primary"
				type="submit"
				disabled={
					!this.periodicInvoiceConceptModel.canEdit() ||
					PropertiesController.getProperty(PropertiesController.FEATURE_DEMO, this.context)
				}>
				<FormattedMessage id="invoice.prepare" />
			</button>
		);

		return buttons;
	}

	/**
	 * Try to get or create invoiceConceptModel based on route. Fetch all invoices if necessary
	 *
	 * @private
	 */
	_initialize(skipFetch = false) {
		//
		const company = this.context.applicationStore.getSelectedCompany();
		if (!company) {
			return;
		}

		// NEW: Create a new invoice if 'new' is found
		if (this.context.applicationStore.currentRouteParams.invoiceId === 'new') {
			this._createNewInvoiceConcept();

			// EDIT: Check if the supplied invoiceId needs to be duplicated
		} else if (!isNaN(parseInt(this.context.applicationStore.currentRouteParams.invoiceId, 10))) {
			const invoiceId = parseInt(this.context.applicationStore.currentRouteParams.invoiceId, 10);
			this.periodicInvoiceConceptModel =
				this.context.applicationStore.periodicInvoicesConceptStore.getInvoiceConceptById(invoiceId);
		}

		// NONE FOUND OR CREATED: If no invoiceConceptModel exists, force fetch of invoiceConcepts from server before trying again
		if (!this.periodicInvoiceConceptModel) {
			if (!skipFetch) {
				const command = new GetPeriodicInvoicesConceptCommand(
					this.context.applicationStore.periodicInvoicesConceptStore,
					company.id
				);
				command.execute(() => {
					this._initialize(true);
				});
			} else {
				console.log('invoiceConcept not found');
			}

			return;
		}

		// Set default values
		this._applyDefaults(company.invoicesSettings);

		// Make sure we always have a minimum of 1 row
		while (this.periodicInvoiceConceptModel.invoiceConceptRows.length < 1) {
			this.addNewInvoiceConceptRow();
		}

		// Update rendering
		this.forceUpdate();

		// Autofocus on selected field
		this._autoFocus();
	}

	/**
	 *
	 * @private
	 */
	_createNewInvoiceConcept() {
		this.periodicInvoiceConceptModel = new PeriodicInvoiceConceptModel();

		const { applicationStore } = this.context;
		const companyBrand = applicationStore.companyBrandStore.find(
			parseInt(CookieController.getCookie(COOKIE_TYPES.SELECTED_COMPANY_BRAND_ID), 10)
		);
		if (companyBrand) {
			this.periodicInvoiceConceptModel.companyBrand = companyBrand;
		}
	}

	/**
	 *
	 * @private
	 */
	_applyDefaults(_invoicesSettings) {
		// Set, override locale based on users preference if invoice is new
		if (!this.periodicInvoiceConceptModel.locale) {
			this.periodicInvoiceConceptModel.locale = this.context.applicationStore.user.isEnglish()
				? Locale.en_US
				: Locale.nl_NL;
		}

		// Set default notes, based on locale
		this._updateNotes();
	}

	/**
	 *
	 * @private
	 */
	_updateNotes() {
		const company = this.context.applicationStore.getSelectedCompany();
		const invoicesSettings = company.invoicesSettings;

		// Get default string or convert default translation object to string
		const defaultEN =
			typeof invoicesSettings.defaultNotesEN === 'object'
				? this.props.intl.formatMessage(invoicesSettings.defaultNotesEN)
				: invoicesSettings.defaultNotesEN;
		const defaultNL =
			typeof invoicesSettings.defaultNotes === 'object'
				? this.props.intl.formatMessage(invoicesSettings.defaultNotes)
				: invoicesSettings.defaultNotes;

		// Is notes one of the default values? Or is notes not set?
		if (
			!this.periodicInvoiceConceptModel.notes ||
			this.periodicInvoiceConceptModel.notes === defaultEN ||
			this.periodicInvoiceConceptModel.notes === defaultNL
		) {
			// Set notes based on locale
			if (this.periodicInvoiceConceptModel.locale === Locale.en_US) {
				this.periodicInvoiceConceptModel.notes = defaultEN;
			} else {
				this.periodicInvoiceConceptModel.notes = defaultNL;
			}
		}
	}

	/**
	 *
	 */
	_autoFocus() {
		// Autofocus on autofocusField
		const fieldToFocus = this.context.applicationStore.periodicInvoicesConceptStore.autofocusField;
		if (fieldToFocus) {
			setTimeout(() => {
				if (this.el && fieldToFocus) {
					const field = this.el.querySelector(`[name="${fieldToFocus}"]`);

					try {
						field.focus();
						const cursorPosition = field.value ? field.value.length : 0;
						field.setSelectionRange(cursorPosition, cursorPosition);
					} catch (e) {
						// Ignore
					}
				}
			}, 100);
		}
	}
}

PeriodicInvoiceConcept.contextType = ApplicationContext;

PeriodicInvoiceConcept.propTypes = {
	intl: PropTypes.object
};

export default injectIntl(PeriodicInvoiceConcept);
